/**
 *
 * RecommendationTaskForm
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"
import { Input, Button, Select } from "antd"

/* eslint-disable react/prefer-stateless-function */
class RecommendationTaskForm extends React.Component {
  isNew = true
  state = {
    id_task: null,
    periodicity: 0,
    name: "",
    loading_save: false,
  }

  componentDidMount = () => {
    const { data } = this.props
    if (data.name) {
      this.isNew = false
    }
    this.setState({ ...Object.assign(this.state, data) })
  }

  onSave = async (toServer = false) => {
    const { data, actionPlan, onFinishSave, collaborators } = this.props
    const params = JSON.parse(JSON.stringify(this.state))
    const isEditTask = !!data.id_task
    delete params.loading_save
    if (!isEditTask) {
      delete params.id_task
    }
    if (params.periodicity === 0) {
      delete params.date_start
      delete params.task_schedules
    }
    if (toServer) {
      if (isEditTask) {
        params._method = "PUT"
      }
      this.setState({ loading_save: true })
      try {
        const url = !isEditTask
          ? `action-plans/${actionPlan.id_action_plan}/tasks`
          : `action-plans/${actionPlan.id_action_plan}/tasks/${params.id_task}`
        const save = await fetchGlobalApi({
          method: "POST",
          endpoint: url,
          data: params,
        })
        this.setState({ loading_save: false })
        returnMessage(save)
        onFinishSave(save.data.data.result)
      } catch (error) {
        this.setState({ loading_save: false })
        returnMessage(error)
      }
    } else {
      this.props.onFinishSave(params)
    }
  }

  render() {
    const { periodicity, name, loading_save } = this.state
    const { style, onCancel, actionPlan } = this.props

    return (
      <div className="RecommendationTaskForm-component" style={style}>
        <div>
          <span style={{ marginBottom: 5, display: "block" }}>
            Ingresa la <b>tarea</b>
          </span>
          <Input
            placeholder="Ejemplo: Realizar reuniones de feedback semanales con mi equipo para su desarrollo"
            maxLength={200}
            onChange={(e) => this.setState({ name: e.target.value })}
            value={name}
          />
        </div>
        <div className="RecommendationTasksForm-component-columns">
          <div>
            <label>Periodicidad</label>
            <Select
              placeholder="Seleccionar"
              value={periodicity}
              style={{ width: 200 }}
              onChange={(e) => this.setState({ periodicity: e })}>
              <Select.Option value={0}>No se repite</Select.Option>
              <Select.Option value={1}>Semanal</Select.Option>
              <Select.Option value={2}>Quincenal</Select.Option>
              <Select.Option value={3}>Mensual</Select.Option>
              <Select.Option value={4}>Trimestral</Select.Option>
              <Select.Option value={5}>Semestral</Select.Option>
              <Select.Option value={6}>Anual</Select.Option>
            </Select>
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <Button onClick={onCancel}>Cancelar</Button>
          <Button
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={() => this.onSave(!!actionPlan.id_action_plan)}
            loading={loading_save}
            disabled={name.length === 0}>
            {this.isNew ? "Agregar" : "Guardar"}
          </Button>
        </div>
      </div>
    )
  }
}

RecommendationTaskForm.propTypes = {}
RecommendationTaskForm.defaultProps = {
  style: {},
  actionPlan: {},
  currentTask: {},
  onFinishSave: () => {},
  defaultEmployee: null,
  data: {},
}

export default RecommendationTaskForm
